"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BarListing = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Label = _interopRequireDefault(require("../baseComponents/Label"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Col = _interopRequireDefault(require("../baseComponents/Col"));

var _TextTruncate = _interopRequireDefault(require("../baseComponents/TextTruncate"));

var _Row = _interopRequireDefault(require("../baseComponents/Row"));

var _index = require("../../index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BarListing = function BarListing(props) {
  var extraComponents = props.toolComponents.map(function (element, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "tool-".concat(index)
    }, " ", element, " ");
  });
  var visualComponents = props.visualComponents.map(function (element, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "visual-".concat(index)
    }, " ", element, " ");
  });
  var mainClasses = (0, _classnames["default"])("barListing-component", props.colorTheme, props.className, props.shapeStyle, {
    "withImage": props.image || props.avatar
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: mainClasses,
    style: props.style
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("left-container", props.clickable && "clickable"),
    onClick: props.onClick
  }, props.image != null && /*#__PURE__*/_react["default"].createElement("div", {
    className: "image"
  }, props.image), props.avatar != null && props.avatar, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text"
  }, /*#__PURE__*/_react["default"].createElement("h5", {
    className: "narrow"
  }, props.title), /*#__PURE__*/_react["default"].createElement("p", {
    className: "mice"
  }, props.description))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "extraComponentContainer"
  }, visualComponents.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("visualComponents", props.clickable && "clickable"),
    onClick: props.onClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "visualComponentsContainer"
  }, visualComponents)), extraComponents.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "toolComponents"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "toolComponentsContainer"
  }, extraComponents))));
};

exports.BarListing = BarListing;
BarListing.Proptypes = {
  image: _propTypes["default"].any,
  avatar: _propTypes["default"].object,
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].array]),
  description: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].array]),
  toolComponents: _propTypes["default"].array,
  visualComponents: _propTypes["default"].array,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  shapeStyle: _propTypes["default"].oneOf(["full-border", "single-border"])
};
BarListing.defaultProps = {
  image: null,
  avatar: null,
  title: null,
  description: null,
  toolComponents: [],
  visualComponents: [],
  className: "",
  style: {},
  onClick: function onClick() {},
  clickable: false,
  shapeStyle: "full-border"
};
var _default = BarListing;
exports["default"] = _default;